import React, { useEffect, useState } from "react";
import Checkbox from "antd/lib/checkbox";
import Tooltip from "antd/lib/tooltip";
import { Slider, Row, Col, Input, Select, InputNumber } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import informationButton from "../../../assets/information-button.svg";
import {
  setWidgetGlobalHorizontalView,
  setWidgetGlobalDataLabel,
  setWidgetGlobalStacked,
  setWidgetGlobalDurationComparision,
  setWidgetDataCountCard,
  setCardSettings,
  setWidgetChartMarkers,
  setWidgetShareOfData,
  setWidgetDataLabelInPercent,
  setCardSeriesAggregation,
  setCardBenchmarkLine,
  setWidgetDuplicateForBrands,
  setWidgetTotalRow,
  setY_attribute,
  setWidgetGradientColor,
  setWidgetMakerSplitCards,
  setWidgetMakerTopPosts,
  setWidgetGlobalDurationComparisionForChart,
  setWidgetGlobalDurationDataForChart,
  setWidgetEnable3D,
  setWidget3dOption,
  setShowMinMaxDataGlobal,
  setShowMaxDataGlobal,
  setShowMinDataGlobal,
  setWidgetChartStylesOption,
  setWidgetSwitchToMedian,
  setCardBenchmarkStaticValue,
  setWidgetGlobalShowDetailsOnCard,
  setWidgetMakerShowHeader,
} from "../../../redux/actions/WidgetMaker/GraphConfig";
import useDebounce from "../../layout/WelcomePage/Worksheets/useDebounce";
import ChartSettingCard from "./ChartSettingCard";
import {
  callNotification,
  getCustomizedDate,
  getPaneIndex,
  getWidgetMakerBrands,
  getWidgetMakerFlag,
  getWindowLocationPath,
  isValidNumber,
} from "../../../redux/constants";
import {
  benchmarkAggregation,
  DEFAULT_CHART_SETTINGS,
  supportedBenchmarkTraceChartTypes,
  supportedChartTypesForPeakAndValley,
} from "../../../redux/constants/enums";
import {
  getChartAttributesFieldConfigAPI,
  setWidgetMakerGraphData,
} from "../../../redux/actions/WidgetMaker/WidgetAPI";
import { setOptionHighChart } from "../../../redux/actions/HighChart";
import moment from "moment";
import {
  setChartAttributesFieldConfig,
  setWidgetMakerApiCallFlag,
} from "../../../redux/actions/WidgetMaker/WidgetMaker";

const ChartSetting = ({ setShowChartSettings }) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const wm_api_flag = useSelector((state) => state.WidgetMaker.wm_api_flag);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const index = getPaneIndex(panes, activeKey);
  const chartAttributesFieldConfig = useSelector(
    (state) => state?.WidgetMaker?.chart_attributes_field_config
  );

  const [showMarkers, setShowMarkers] = useState(true);

  const [stacked, setStacked] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.is_stacked
  );
  const [stackedDisabled, setStackedDisabled] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.is_stacked_disabled
  );
  const [dataLabel, setDataLabel] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.global_data_label
  );
  const [chartStyles, setChartStyles] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.chart_styles
  );
  const debouncedChartStyles = useDebounce(chartStyles, 500);
  const [enable3D, setEnable3D] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.show_3d
  );
  const [showSliders, setShowSliders] = useState(
    widgetGraphConfig?.chart_settings?.show_3d
  );
  const [alphaValue, setAlphaValue] = useState(
    widgetGraphConfig?.chart_settings?.settings_3d?.alpha
      ? widgetGraphConfig?.chart_settings?.settings_3d?.alpha
      : DEFAULT_CHART_SETTINGS[widgetGraphConfig?.chart_type]?.alpha ?? 0
  );
  const [betaValue, setBetaValue] = useState(
    widgetGraphConfig?.chart_settings?.settings_3d?.beta
      ? widgetGraphConfig?.chart_settings?.settings_3d?.beta
      : DEFAULT_CHART_SETTINGS[widgetGraphConfig?.chart_type]?.beta ?? 0
  );
  const [depthValue, setDepthValue] = useState(
    widgetGraphConfig?.chart_settings?.settings_3d?.depth
      ? widgetGraphConfig?.chart_settings?.settings_3d?.depth
      : DEFAULT_CHART_SETTINGS[widgetGraphConfig?.chart_type]?.depth ?? 100
  );
  const alpha = useDebounce(alphaValue, 1000);
  const beta = useDebounce(betaValue, 1000);
  const depth = useDebounce(depthValue, 1000);
  const [horizontalView, setHorizontalView] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.show_horizontal_view
  );
  const [duplicateForBrands, setDuplicateForBrands] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.duplicate_for_brands
  );
  const [showDetailsOnCard, setShowDetailsOnCard] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.show_details_on_card
  );
  const [switchToMedian, setSwitchToMedian] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.show_as_median
  );
  // const [dynamicRadius, setDynamicRadius] = useState(
  //   widgetGraphConfig && widgetGraphConfig?.chart_settings?.dynamic_radius
  // );
  // const [borderSentiment, setBorderSentiment] = useState(
  //   widgetGraphConfig && widgetGraphConfig?.chart_settings?.border_sentiment
  // );
  const [dataLabelInPercent, setDataLabelInPercent] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.chart_percent
  );
  const [gradientColor, setGradientColor] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.gradient_color
  );
  const [markers, setMarkers] = useState(
    widgetGraphConfig && widgetGraphConfig?.show_marker
  );
  const [dataCountCard, setDataCountCard] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.data_count_card
  );
  const [durationComparision, setDurationComparision] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.duration_comparison
  );
  const [durationComparisionForChart, setDurationComparisionForChart] =
    useState(
      widgetGraphConfig &&
        widgetGraphConfig?.chart_settings?.show_previous_duration_comparison
    );
  const [durationDataForChart, setDurationDataForChart] = useState(
    widgetGraphConfig &&
      widgetGraphConfig?.chart_settings?.show_previous_duration_data
  );

  const [showMinMaxData, setShowMinMaxData] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.show_min_max_data
  );

  const [showPeak, setShowPeak] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.show_peak
  );

  const [showValley, setShowValley] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.show_valley
  );

  const [shareOfData, setShareOfData] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.card_percent
  );
  const [showBenchmarkTraceOptions, setShowBenchmarkTraceOptions] =
    useState(false);
  const [benchmark_line, setBenchmarkLine] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.benchmark_line
  );
  const [groupLineAgg, setGroupLineAgg] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.group_line_agg
  );
  // Set initial config; default min=1, max=100
  const [benchmarkValueConfig, setBenchmarkValueConfig] = useState({
    min: 1,
    max: null,
    value: widgetGraphConfig?.chart_settings?.benchmark_static_value ?? null, // default to min if undefined
  });
  const debouncedBenchmarkValueConfig = useDebounce(benchmarkValueConfig, 500); // for adding some delay
  const [
    showErrorMessageForBenchmarkValue,
    setShowErrorMessageForBenchmarkValue,
  ] = useState(false);
  const [total, setTotal] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.total_row
  );
  const [splitCards, setSplitCards] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.split_cards
  );
  const [topPosts, setTopPosts] = useState(
    widgetGraphConfig && widgetGraphConfig?.chart_settings?.top_posts_in_cards
  );
  const [showFilterByHeader, setShowFilterByHeader] = useState(
    widgetGraphConfig &&
      typeof widgetGraphConfig?.chart_settings?.show_header === "boolean"
      ? widgetGraphConfig?.chart_settings?.show_header
      : true
  );
  useEffect(() => {
    if (widgetGraphConfig?.chart_type === "combination") {
      let marker = false;
      widgetGraphConfig &&
        widgetGraphConfig?.y_axis_settings?.map((d, i) => {
          if (
            d?.show_as !== "bar" &&
            widgetGraphConfig?.chart_type === "combination"
          ) {
            marker = true;
          }
        });
      setShowMarkers(marker);
    }
  }, [widgetGraphConfig?.y_axis_settings]);
  // to set stack checkbox value according to charttype changes
  useEffect(() => {
    if (widgetGraphConfig?.chart_type === "combination") {
      if (widgetGraphConfig?.chart_settings?.is_stacked_disabled) {
        setStackedDisabled(true);
      } else {
        setStackedDisabled(false);
      }
      if (widgetGraphConfig?.chart_settings?.is_stacked) {
        setStacked(true);
      } else {
        setStacked(false);
      }
      if (widgetGraphConfig?.chart_settings?.gradient_color) {
        setGradientColor(true);
      } else {
        setGradientColor(false);
      }
    }
  }, [
    widgetGraphConfig?.chart_settings?.is_stacked_disabled,
    widgetGraphConfig?.chart_settings?.is_stacked,
    widgetGraphConfig?.chart_settings?.gradient_color,
  ]);
  const checkSpanningExist = (graphConfig) => {
    let updatedWidgetGraphConfig = { ...graphConfig };
    // check for : If spanning on x_axis or breackdown_by , remove this and show notification for that
    let isSpaningEnable = false;
    let spanningOn = null;
    if (updatedWidgetGraphConfig?.x_axis?.span_on) {
      isSpaningEnable = true;
      spanningOn = updatedWidgetGraphConfig?.x_axis?.trace_name
        ? updatedWidgetGraphConfig?.x_axis?.trace_name
        : updatedWidgetGraphConfig?.x_axis?.attribute;
      updatedWidgetGraphConfig.x_axis.span_on = false;
    } else if (
      Array.isArray(updatedWidgetGraphConfig?.breakdown_by) &&
      updatedWidgetGraphConfig?.breakdown_by?.length
    ) {
      const updatedBreakdown = updatedWidgetGraphConfig?.breakdown_by?.map(
        (b, i) => {
          if (b?.span_on) {
            isSpaningEnable = true;
            spanningOn = b?.trace_name ? b?.trace_name : b?.attribute;
            b.span_on = false;
          }
          return b;
        }
      );
      if (isSpaningEnable) {
        updatedWidgetGraphConfig.breakdown_by = [...updatedBreakdown];
      }
    }
    return {
      isSpaningEnable: isSpaningEnable,
      updatedWidgetGraphConfig: updatedWidgetGraphConfig,
      spanningOn: spanningOn,
    };
  };
  useEffect(() => {
    if (
      widgetGraphConfig?.chart_type === "area" ||
      widgetGraphConfig?.chart_type === "bar" ||
      widgetGraphConfig?.chart_type === "horizontal-bar" ||
      widgetGraphConfig?.chart_type === "pie" ||
      widgetGraphConfig?.chart_type === "donut"
    ) {
      const sliderValues = {
        alpha: alpha,
        beta: beta,
        depth: depth,
      };
      dispatch(setWidget3dOption(sliderValues, widgetGraphConfig));
    }
  }, [alpha, beta, depth]);

  const handleSliderChange = (value, sliderType) => {
    switch (sliderType) {
      case "alpha":
        setAlphaValue(value);
        break;
      case "beta":
        setBetaValue(value);
        break;
      case "depth":
        setDepthValue(value);
        break;
      default:
        break;
    }
  };
  const handleChartStyles = (value, styleType) => {
    let updatedChartStyles = new Object({ ...chartStyles });
    switch (styleType) {
      case "startColor":
        updatedChartStyles.startColor = value;
        break;
      case "endColor":
        updatedChartStyles.endColor = value;
        break;
      case "dataLabelColor":
        updatedChartStyles.dataLabelColor = value;
        break;
      default:
        break;
    }
    setChartStyles(updatedChartStyles);
  };
  useEffect(() => {
    if (debouncedChartStyles) {
      dispatch(
        setWidgetChartStylesOption(debouncedChartStyles, widgetGraphConfig)
      );
    }
  }, [debouncedChartStyles]);
  const SelectCombinationSetting = (e) => {
    if (e.target.value === "Show Lollipop Horizontally") {
      setHorizontalView(!horizontalView);
      dispatch(
        setWidgetGlobalHorizontalView(e.target.checked, widgetGraphConfig)
      );
    }
    if (e.target.value === "ShowMinMaxData") {
      setShowMinMaxData(!showMinMaxData);
      dispatch(setShowMinMaxDataGlobal(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "ShowMaxData") {
      if (
        widgetGraphConfig?.chart_type === "bar" ||
        widgetGraphConfig?.chart_type === "horizontal-bar"
      ) {
        setShowPeak(!showPeak);
        setDurationComparisionForChart(false);
        dispatch(
          setWidgetGlobalDurationComparisionForChart(false, widgetGraphConfig)
        );
        dispatch(setShowMaxDataGlobal(e.target.checked, widgetGraphConfig));

        let graphConfig = {
          ...widgetGraphConfig,
        };
        graphConfig.chart_settings.show_peak = !showPeak;
        callChartAPI(graphConfig);
      } else {
        setShowPeak(!showPeak);
        setDurationComparisionForChart(false);
        dispatch(
          setWidgetGlobalDurationComparisionForChart(false, widgetGraphConfig)
        );
        dispatch(setShowMaxDataGlobal(e.target.checked, widgetGraphConfig));
      }
    }
    if (e.target.value === "ShowMinData") {
      if (
        widgetGraphConfig?.chart_type === "bar" ||
        widgetGraphConfig?.chart_type === "horizontal-bar"
      ) {
        setShowValley(!showValley);
        setDurationComparisionForChart(false);
        dispatch(
          setWidgetGlobalDurationComparisionForChart(false, widgetGraphConfig)
        );
        dispatch(setShowMinDataGlobal(e.target.checked, widgetGraphConfig));

        let graphConfig = {
          ...widgetGraphConfig,
        };
        graphConfig.chart_settings.show_valley = !showValley;
        callChartAPI(graphConfig);
      } else {
        setShowValley(!showValley);
        setDurationComparisionForChart(false);
        dispatch(
          setWidgetGlobalDurationComparisionForChart(false, widgetGraphConfig)
        );
        dispatch(setShowMinDataGlobal(e.target.checked, widgetGraphConfig));
      }
    }
    if (e.target.value === "Show Data Labels") {
      setDataLabel(!dataLabel);
      dispatch(setWidgetGlobalDataLabel(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "Show Details on Card") {
      setShowDetailsOnCard(!showDetailsOnCard);
      dispatch(
        setWidgetGlobalShowDetailsOnCard(e.target.checked, widgetGraphConfig)
      );
      if (widgetGraphConfig?.chart_type === "treemap") {
        dispatch(setOptionHighChart(null));
      }
    }
    if (e.target.value === "Enable 3D") {
      const newEnable3D = !enable3D;
      setEnable3D(newEnable3D);
      setShowSliders(newEnable3D);
      dispatch(setWidgetEnable3D(newEnable3D, widgetGraphConfig));
    }
    if (e.target.value === "Duplicate for selected brands") {
      setDuplicateForBrands(!duplicateForBrands);
      dispatch(
        setWidgetDuplicateForBrands(e.target.checked, widgetGraphConfig)
      );
    }
    if (e.target.value === "SwitchToMedian") {
      setSwitchToMedian(!switchToMedian);
      dispatch(setWidgetSwitchToMedian(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "Percent Chart") {
      setDataLabelInPercent(!dataLabelInPercent);
      dispatch(
        setWidgetDataLabelInPercent(e.target.checked, widgetGraphConfig)
      );
    }
    if (e.target.value === "Gradient Color") {
      setGradientColor(!gradientColor);
      dispatch(setWidgetGradientColor(e.target.checked, widgetGraphConfig));
      if (widgetGraphConfig?.chart_type === "treemap") {
        dispatch(setOptionHighChart(null));
      }
    }
    if (e.target.value === "Stacked") {
      if (!e.target.checked) {
        setDataLabelInPercent(false);
        setGradientColor(true);
        let updatedWidgetGraphConfig = { ...widgetGraphConfig };
        updatedWidgetGraphConfig.chart_settings.chart_percent = false;
        updatedWidgetGraphConfig.chart_settings.gradient_color = true;
        dispatch(setWidgetDataLabelInPercent(false, updatedWidgetGraphConfig));
        dispatch(setWidgetGradientColor(true, updatedWidgetGraphConfig));
      } else {
        setGradientColor(false);
        dispatch(setWidgetGradientColor(false, widgetGraphConfig));
      }
      setStacked(!stacked);
      dispatch(setWidgetGlobalStacked(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "Show Data Count Cards") {
      setDataCountCard(!dataCountCard);
      dispatch(setWidgetDataCountCard(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "Previous Duration Comparison") {
      setDurationComparision(!durationComparision);
      dispatch(
        setWidgetGlobalDurationComparision(e.target.checked, widgetGraphConfig)
      );
    }
    if (e.target.value === "PreviousDurationComparisonForChart") {
      if (
        e.target.checked &&
        durationDataForChart &&
        ["grid"]?.includes(widgetGraphConfig?.chart_type)
      ) {
        let updatedWidgetGraphConfig = { ...widgetGraphConfig };
        updatedWidgetGraphConfig.chart_settings.show_previous_duration_comparison =
          e.target.checked;
        updatedWidgetGraphConfig.chart_settings.show_previous_duration_data =
          !durationDataForChart;

        // check for : If spanning on x_axis or breackdown_by , remove this and show notification for that
        let checkRes = checkSpanningExist(updatedWidgetGraphConfig);
        if (checkRes?.isSpaningEnable) {
          callNotification(
            checkRes?.spanningOn
              ? "Spanning on " + checkRes?.spanningOn + " disabled."
              : "Spanning disabled.",
            "alert"
          );
        }

        setDurationComparisionForChart(!durationComparisionForChart);
        setDurationDataForChart(!durationDataForChart);
        dispatch(
          setWidgetGlobalDurationComparisionForChart(
            e.target.checked,
            checkRes?.updatedWidgetGraphConfig
              ? checkRes?.updatedWidgetGraphConfig
              : updatedWidgetGraphConfig
          )
        );
        dispatch(
          setWidgetGlobalDurationDataForChart(
            !durationDataForChart,
            checkRes?.updatedWidgetGraphConfig
              ? checkRes?.updatedWidgetGraphConfig
              : updatedWidgetGraphConfig
          )
        );
      } else {
        // check for : If spanning on x_axis or breackdown_by , remove this and show notification for that
        let checkRes = ["grid"]?.includes(widgetGraphConfig?.chart_type)
          ? checkSpanningExist(widgetGraphConfig)
          : null;
        if (checkRes?.isSpaningEnable) {
          callNotification(
            checkRes?.spanningOn
              ? "Spanning on " + checkRes?.spanningOn + " disabled."
              : "Spanning disabled.",
            "alert"
          );
        }
        setDurationComparisionForChart(!durationComparisionForChart);
        dispatch(
          setWidgetGlobalDurationComparisionForChart(
            e.target.checked,
            checkRes?.updatedWidgetGraphConfig
              ? checkRes?.updatedWidgetGraphConfig
              : widgetGraphConfig
          )
        );
      }
      setShowPeak(false);
      setShowValley(false);
      dispatch(setShowMaxDataGlobal(false, widgetGraphConfig));
      dispatch(setShowMinDataGlobal(false, widgetGraphConfig));
    }
    if (e.target.value === "PreviousDurationDataForChart") {
      if (
        e.target.value &&
        durationComparisionForChart &&
        ["grid"]?.includes(widgetGraphConfig?.chart_type)
      ) {
        let updatedWidgetGraphConfig = { ...widgetGraphConfig };
        updatedWidgetGraphConfig.chart_settings.show_previous_duration_comparison =
          !durationComparisionForChart;
        updatedWidgetGraphConfig.chart_settings.show_previous_duration_data =
          e.target.value;
        // check for : If spanning on x_axis or breackdown_by , remove this and show notification for that
        let checkRes = checkSpanningExist(updatedWidgetGraphConfig);
        if (checkRes?.isSpaningEnable) {
          callNotification(
            checkRes?.spanningOn
              ? "Spanning on " + checkRes?.spanningOn + " disabled."
              : "Spanning disabled.",
            "alert"
          );
        }
        setDurationDataForChart(!durationDataForChart);
        setDurationComparisionForChart(!durationComparisionForChart);
        dispatch(
          setWidgetGlobalDurationComparisionForChart(
            !durationComparisionForChart,
            checkRes?.updatedWidgetGraphConfig
              ? checkRes?.updatedWidgetGraphConfig
              : updatedWidgetGraphConfig
          )
        );
        dispatch(
          setWidgetGlobalDurationDataForChart(
            e.target.checked,
            checkRes?.updatedWidgetGraphConfig
              ? checkRes?.updatedWidgetGraphConfig
              : updatedWidgetGraphConfig
          )
        );
      } else {
        // check for : If spanning on x_axis or breackdown_by , remove this and show notification for that
        let checkRes = ["grid"]?.includes(widgetGraphConfig?.chart_type)
          ? checkSpanningExist(widgetGraphConfig)
          : null;
        if (checkRes?.isSpaningEnable) {
          callNotification(
            checkRes?.spanningOn
              ? "Spanning on " + checkRes?.spanningOn + " disabled."
              : "Spanning disabled.",
            "alert"
          );
        }
        setDurationDataForChart(!durationDataForChart);
        dispatch(
          setWidgetGlobalDurationDataForChart(
            e.target.checked,
            checkRes?.updatedWidgetGraphConfig
              ? checkRes?.updatedWidgetGraphConfig
              : widgetGraphConfig
          )
        );
      }
    }

    if (e.target.value === "Share of Data") {
      setShareOfData(!shareOfData);
      dispatch(setWidgetShareOfData(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "total") {
      setTotal(!total);
      dispatch(setWidgetTotalRow(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "split_cards") {
      setSplitCards(!splitCards);
      dispatch(setWidgetMakerSplitCards(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "top_posts_in_cards") {
      setTopPosts(!topPosts);
      dispatch(setWidgetMakerTopPosts(e.target.checked, widgetGraphConfig));
    }
    if (e.target.value === "show_header") {
      setShowFilterByHeader(!showFilterByHeader);
      dispatch(setWidgetMakerShowHeader(e.target.checked, widgetGraphConfig));
    }
    // if (e.target.value === "dynamic_radius") {
    //   setDynamicRadius(!dynamicRadius);
    //   dispatch(
    //     setWidgetMakerDyanamicRadius(e.target.checked, widgetGraphConfig)
    //   );
    // }
    // if (e.target.value === "border_sentiment") {
    //   setBorderSentiment(!borderSentiment);
    //   dispatch(
    //     setWidgetMakerBorderSentiment(e.target.checked, widgetGraphConfig)
    //   );
    // }
  };

  const closeChartSettings = () => {
    setShowChartSettings(false);

    //for half data in card
    if (
      widgetGraphConfig?.card_settings[
        widgetGraphConfig?.card_settings.length - 1
      ]?.x_axis
    ) {
      if (
        !widgetGraphConfig?.card_settings[
          widgetGraphConfig?.card_settings.length - 1
        ]?.x_axis ||
        !widgetGraphConfig?.card_settings[
          widgetGraphConfig?.card_settings.length - 1
        ]?.y_series
      ) {
        let obj = { ...widgetGraphConfig };
        obj.card_settings = [];
        dispatch(setCardSettings(obj));
      }
    }

    if (widgetGraphConfig?.edit_fields) {
      dispatch(
        setY_attribute({
          ...widgetGraphConfig,
          [`edit_fields`]: {
            ...widgetGraphConfig.edit_fields,
            boolValue: false,
          },
        })
      );
    }

    dispatch(
      setChartAttributesFieldConfig({
        ...chartAttributesFieldConfig,
        open_chart_setting_flag: false,
        selected_chart_type: widgetChartType,
        // Reset selected_field to default when closing chart settings
        selected_field: "x_axis",
        actual_field_clicked: "x_axis",
      })
    );

    // Call Graph Info API
    let updatedAxisPanelAtt = {
      ...widgetGraphConfig,
      // chart_attributes_field_config: {
      //   ...chartAttributesFieldConfig,
      //   open_chart_setting_flag: false,
      //   selected_chart_type: widgetChartType,
      // },
    };
    let payloadObj = {
      authParams: authParams,
      chart_type: widgetChartType,
      axisPanelAtt: updatedAxisPanelAtt,
      chartAttributesFieldConfig: {
        ...chartAttributesFieldConfig,
        open_chart_setting_flag: false,
        selected_chart_type: widgetChartType,
        selected_field: "x_axis",
        actual_field_clicked: "x_axis",
      },
    };
    authParams && dispatch(getChartAttributesFieldConfigAPI(payloadObj));
  };
  const widgetChartType = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.chart_type
  );
  const widgetMakerGraphData = useSelector(
    (state) =>
      state?.WidgetAPI?.widget_maker_graph_data?.data?.[
        widgetChartType === "combination"
          ? "combination"
          : widgetChartType === "horizontal-bar"
          ? "bar"
          : widgetChartType === "donut"
          ? "pie"
          : widgetChartType
      ]
  );

  const handleChartMarkers = (e, i) => {
    setMarkers(!markers);
    dispatch(setWidgetChartMarkers(e.target.checked, widgetGraphConfig));
  };

  const changeSeriesAggregation = (value) => {
    setGroupLineAgg(value);
    let benchmarkStaticValue = null;
    if (value === "custom") {
      benchmarkStaticValue = benchmarkValueConfig?.value
        ? benchmarkValueConfig?.value
        : 1;
      setBenchmarkValueConfig((prevConfig) => ({
        ...prevConfig,
        value: benchmarkStaticValue,
      }));
      setShowErrorMessageForBenchmarkValue(false);
      if (benchmarkStaticValue === 1) {
        callNotification(
          "Default value set as 1. Change value to refresh the chart data.",
          "info"
        );
      }
    }
    dispatch(
      setCardSeriesAggregation(
        value === "None" ? null : value,
        widgetGraphConfig,
        value === "custom" ? benchmarkStaticValue : null
      )
    );
  };
  const handleBenchmarkLine = (e) => {
    if (e.target.value === "Benchmark Line") {
      if (e.target.checked) {
        setGroupLineAgg("avg");
        dispatch(setCardSeriesAggregation("avg", widgetGraphConfig));
      } else if (e.target.checked === false) {
        setGroupLineAgg(null);
        dispatch(setCardSeriesAggregation(null, widgetGraphConfig));
      }
      setBenchmarkLine(e.target.checked);
      dispatch(setCardBenchmarkLine(e.target.checked, widgetGraphConfig));
    }
  };

  const callChartAPI = (graphConfig) => {
    dispatch(setOptionHighChart({}));
    let y_series_array = [];
    y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
      (key) => widgetGraphConfig?.y_axis[key]
    );
    const y_series_array1 = y_series_array;
    let y_series_flag = getWidgetMakerFlag(widgetGraphConfig, wm_api_flag);

    y_series_array = y_series_array?.filter((el) => el?.attribute);
    if (
      widgetGraphConfig?.chart_type === "bubble" ||
      widgetGraphConfig?.chart_type === "heatmap" ||
      widgetGraphConfig?.chart_type === "sunburst" ||
      widgetGraphConfig?.chart_type === "wordcloud" ||
      widgetGraphConfig?.chart_type === "donut" ||
      widgetGraphConfig?.chart_type === "pie"
    ) {
      y_series_array =
        y_series_array?.length > 1 ? [y_series_array[0]] : y_series_array;
    }

    const d = new Date();
    let utcOffset = d.getTimezoneOffset();

    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let card_settings_data = [];
    widgetGraphConfig?.card_settings?.map((d) => {
      if (
        (d?.x_axis?.attribute || (!d?.x_axis?.attribute && d?.y_series)) &&
        d?.y_series?.attribute
      ) {
        card_settings_data = [
          ...card_settings_data,
          {
            x_axis:
              d?.x_axis == null
                ? null
                : Object.keys(d?.x_axis).length == 0
                ? null
                : d?.x_axis,
            y_series: d?.y_series,
          },
        ];
      }
    });

    let pivot_index = widgetGraphConfig?.breakdown_by?.findIndex(
      (d) => d?.is_pivot
    );

    if (wm_api_flag) {
      dispatch(setWidgetMakerApiCallFlag(false));
    }
    dispatch(setOptionHighChart({}));
    let card_settings_index = widgetGraphConfig?.card_settings?.length - 1;
    if (
      widgetGraphConfig?.card_settings &&
      Array.isArray(widgetGraphConfig?.card_settings)
    ) {
      for (let i = widgetGraphConfig?.card_settings?.length - 1; i >= 0; i--) {
        let card = widgetGraphConfig?.card_settings?.[i];
        if (card?.x_axis?.atrribute || card?.y_series) {
          card_settings_index = i;
          break;
        }
      }
    }
    let graphObject = {
      brand_list: [
        {
          brand_id: 600,
        },
      ],
      start_date: widgetGraphConfig?.duration?.from
        ? widgetGraphConfig?.duration?.from
        : defaultDuration?.from,
      end_date: widgetGraphConfig?.duration?.to
        ? widgetGraphConfig?.duration?.to
        : defaultDuration?.to,
      brands:
        widgetGraphConfig?.brands?.length > 0
          ? widgetGraphConfig?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
      isBrandModified: widgetGraphConfig?.brands?.length > 0 ? true : false,

      filters:
        widgetGraphConfig?.filters?.length > 0
          ? widgetGraphConfig?.filters
          : [],
      x_axis: widgetGraphConfig?.x_axis && widgetGraphConfig?.x_axis,
      // Break down data
      y_axes:
        widgetGraphConfig?.breakdown_by?.length > 0
          ? widgetGraphConfig?.breakdown_by
          : widgetGraphConfig?.filter_by?.length > 0
          ? widgetGraphConfig?.filter_by
          : null,
      // y axis data
      y_series: y_series_array && y_series_array,
      // for filter dropdown in widget header
      filter_dropdown:
        widgetGraphConfig?.filter_dropdown?.length > 0
          ? widgetGraphConfig?.filter_dropdown
          : [],
      widget_name: "abc",
      chart: {
        chart_type:
          widgetGraphConfig?.chart_type === "donut"
            ? "pie"
            : widgetGraphConfig?.chart_type,
        rich_fields_content: widgetGraphConfig?.rich_fields_content,
        chart_settings: {
          ...widgetGraphConfig?.chart_settings,
          duration_comparison:
            widgetGraphConfig?.chart_settings?.duration_comparison,
          show_previous_duration_comparison:
            widgetGraphConfig?.chart_settings
              ?.show_previous_duration_comparison,
          show_previous_duration_data:
            widgetGraphConfig?.chart_settings?.show_previous_duration_data,
          show_data_labels:
            widgetGraphConfig?.chart_settings?.global_data_label,
          show_details_on_card:
            widgetGraphConfig?.chart_settings?.show_details_on_card,
          show_as_median: widgetGraphConfig?.chart_settings?.show_as_median,
          show_3d: widgetGraphConfig?.chart_settings?.show_3d,
          settings_3d: widgetGraphConfig?.chart_settings?.settings_3d,
          show_label_names: widgetGraphConfig?.chart_settings?.show_label_names,
          duplicate_for_brands: widgetGraphConfig?.chart_settings
            ?.duplicate_for_brands
            ? widgetGraphConfig?.chart_settings?.duplicate_for_brands
            : false,
          is_stacked: widgetGraphConfig?.chart_settings?.is_stacked,
          show_count_cards: widgetGraphConfig?.chart_settings?.data_count_card,
          show_horizontal_view:
            widgetGraphConfig?.chart_settings?.show_horizontal_view,
          card_percent: widgetGraphConfig?.chart_settings?.card_percent,
          chart_percent: widgetGraphConfig?.chart_settings?.chart_percent,
          gradient_color: widgetGraphConfig?.chart_settings?.gradient_color,
          total_row: widgetGraphConfig?.chart_settings?.total_row,
          split_cards: widgetGraphConfig?.chart_settings?.split_cards,
          wordcloud_color: widgetGraphConfig?.chart_settings?.wordcloud_color,
          top_posts_in_cards:
            widgetGraphConfig?.chart_settings?.top_posts_in_cards,
          show_header:
            typeof widgetGraphConfig?.chart_settings?.show_header === "boolean"
              ? widgetGraphConfig?.chart_settings?.show_header
              : true,
          planned_value: widgetGraphConfig?.chart_settings?.planned_value,
          chart_property: {
            chart_name: widgetGraphConfig?.chart_property?.chart_name,
            legend_position: "top",
            y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
            no_of_top_posts: widgetGraphConfig?.chart_property?.no_of_top_posts,
          },
          y_axes_settings: widgetGraphConfig?.y_axis_settings,
          cards_settings: card_settings_data ? card_settings_data : null,
          show_peak: widgetGraphConfig?.chart_settings?.show_peak,
          show_valley: widgetGraphConfig?.chart_settings?.show_valley,
          chart_styles: widgetGraphConfig?.chart_settings?.chart_styles || null,
          cluster_chart_type:
            widgetGraphConfig?.chart_settings?.cluster_chart_type,
          cluster_style: widgetGraphConfig?.chart_settings?.cluster_style,
        },
      },
      card_settings_index: card_settings_index,
      widgetGraphConfig: widgetGraphConfig,
      order_by:
        widgetGraphConfig?.chart_type === "post-card" ||
        widgetGraphConfig?.chart_type === "survey-card" ||
        widgetGraphConfig?.chart_type === "review-card" ||
        widgetGraphConfig?.chart_type === "author-card" ||
        widgetGraphConfig?.chart_type === "prolific-user"
          ? widgetGraphConfig?.order_by
          : null,
      utcOffset: utcOffset,
      edit: widgetGraphConfig?.edit,
      filter_by_data: widgetGraphConfig?.filter_by_data,
      filter_by: widgetGraphConfig?.postcard_pills_filter,
      tags: widgetGraphConfig?.tags ? widgetGraphConfig?.tags : [],

      filter_by_dropdown:
        widgetGraphConfig?.filter_by_dropdown?.length > 0
          ? widgetGraphConfig?.filter_by_dropdown
          : [],
      filter_by_dropdown_data:
        widgetGraphConfig?.filter_by_dropdown_data?.length > 0
          ? widgetGraphConfig?.filter_by_dropdown_data
          : [],
      multilevel_breakdown: widgetGraphConfig?.multilevel_breakdown || null,
    };

    if (
      widgetGraphConfig?.x_axis &&
      widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
      (widgetGraphConfig?.chart_type === "combination" ||
        widgetGraphConfig?.chart_type === "line" ||
        widgetGraphConfig?.chart_type === "bar" ||
        widgetGraphConfig?.chart_type === "horizontal-bar" ||
        widgetGraphConfig?.chart_type === "lollipop" ||
        widgetGraphConfig?.chart_type === "area")
    ) {
      authParams && dispatch(setWidgetMakerGraphData(authParams, graphObject));
    }
  };
  // to be check and setShowBenchmarkTraceOptions
  useEffect(() => {
    // console.log("widgetGraphConfig", widgetGraphConfig);
    // console.log(
    //   "widgetGraphConfig?.brands : ",
    //   widgetGraphConfig?.brands,
    //   "brandlogicalgroup : ",
    //   brandlogicalgroup,
    //   "brands : ",
    //   brands
    // );
    if (
      !widgetGraphConfig?.breakdown_by?.[0]?.attribute &&
      supportedBenchmarkTraceChartTypes?.includes(widgetGraphConfig?.chart_type)
    ) {
      let widgetMakerBrands = getWidgetMakerBrands({
        widgetGraphConfig,
        brandlogicalgroup,
        brands,
      });
      if (
        widgetMakerBrands &&
        ((widgetMakerBrands[0]?.competitor &&
          widgetMakerBrands[0]?.competitorList?.length > 0) ||
          widgetMakerBrands?.length)
        // && !widgetMakerBrands[0]?.group // now support added for logical and single brand
      ) {
        setShowBenchmarkTraceOptions(true);
      } else if (brandlogicalgroup && brandlogicalgroup?.length > 0) {
        setShowBenchmarkTraceOptions(true); // making true // now support added for logical and single brand
      } else if (brands && brands?.length > 0) {
        setShowBenchmarkTraceOptions(true);
      } else {
        setShowBenchmarkTraceOptions(false);
      }
    } else {
      setShowBenchmarkTraceOptions(false);
    }
  }, [widgetGraphConfig?.chart_type, widgetGraphConfig?.brands]);
  const handleChangeBrandBenchmarkStaticValue = (value) => {
    let newValue = value;
    // Allow null (empty) input with triggering error immediately
    if (newValue === null) {
      setBenchmarkValueConfig((prev) => ({ ...prev, value: null }));
      setShowErrorMessageForBenchmarkValue(true);
      return;
    }
    if (benchmarkValueConfig && isValidNumber(newValue)) {
      setBenchmarkValueConfig((prevConfig) => ({
        ...prevConfig,
        value: newValue,
      }));
      if (
        newValue >= benchmarkValueConfig?.min &&
        (benchmarkValueConfig?.max !== null
          ? newValue <= benchmarkValueConfig?.max
          : true)
      ) {
        setShowErrorMessageForBenchmarkValue(false);
      } else {
        setShowErrorMessageForBenchmarkValue(true);
      }
    } else {
      setShowErrorMessageForBenchmarkValue(true);
    }
  };
  useEffect(() => {
    if (
      debouncedBenchmarkValueConfig &&
      debouncedBenchmarkValueConfig?.value !== null &&
      !showErrorMessageForBenchmarkValue
    ) {
      if (
        debouncedBenchmarkValueConfig?.value >=
          debouncedBenchmarkValueConfig?.min &&
        (debouncedBenchmarkValueConfig?.max !== null
          ? debouncedBenchmarkValueConfig?.value <=
            debouncedBenchmarkValueConfig?.max
          : true)
      ) {
        // console.log(
        //   "\n\n\n ***************** Valid value : ",
        //   debouncedBenchmarkValueConfig?.value,
        // );
        dispatch(
          setCardBenchmarkStaticValue(
            debouncedBenchmarkValueConfig?.value,
            widgetGraphConfig
          )
        );
      }
    }
  }, [debouncedBenchmarkValueConfig]);
  const pathName = getWindowLocationPath()?.toLowerCase();
  // console.log("showBenchmarkTraceOptions", showBenchmarkTraceOptions);
  return (
    <>
      <div
        onClick={closeChartSettings}
        className={`d-flex cursor-pointer align-items-center p-15 ${
          authParams?.theme_type === "1" ? "text_regular" : "blue-text"
        } border-bottom border-color`}
      >
        <ArrowLeftOutlined />
        <a className="ml-1">Back</a>
      </div>
      <div
        className="custom_scroll1 mr-1 pt-15 widgetMaker_acc"
        style={{
          overflow: "auto",
          maxHeight: "calc(100vh - 10.4rem)",
        }}
      >
        <div className="pl-15">
          <div className="font-weight600 mb-15 line-height-normal text_heading text-transform__capitalize">
            {widgetGraphConfig?.chart_type} chart settings
          </div>

          {widgetGraphConfig?.chart_type === "grid" && (
            <>
              <Checkbox
                disabled={
                  widgetGraphConfig?.breakdown_by?.length > 0 ? true : false
                }
                value="total"
                className="text_regular m-0 mb-2 line-height-normal d-flex"
                onChange={SelectCombinationSetting}
                checked={total}
              >
                Show Total Row
              </Checkbox>
            </>
          )}

          {widgetGraphConfig?.chart_type === "lollipop" ? (
            <>
              <Checkbox
                value="Show Lollipop Horizontally"
                className="text_regular m-0 mb-2 d-flex"
                onChange={SelectCombinationSetting}
                checked={horizontalView}
              >
                View Horizontally
              </Checkbox>
            </>
          ) : (
            ""
          )}

          {widgetGraphConfig?.chart_type === "lollipop" &&
          widgetGraphConfig?.y_axis?.y_series_2?.attribute ? (
            <>
              <Checkbox
                value="Percent Chart"
                className="text_regular  m-0 mb-2 d-flex"
                onChange={SelectCombinationSetting}
                checked={dataLabelInPercent}
              >
                Percent Chart
              </Checkbox>
              <Checkbox
                value="Gradient Color"
                className="text_regular m-0 mb-2 d-flex "
                onChange={SelectCombinationSetting}
                checked={gradientColor}
              >
                Gradient Color
              </Checkbox>
            </>
          ) : (
            ""
          )}

          {widgetGraphConfig?.chart_type === "progress-kpi" ||
          widgetGraphConfig?.chart_type === "pie" ||
          widgetGraphConfig?.chart_type === "donut" ||
          widgetGraphConfig?.chart_type === "rich-text" ||
          widgetGraphConfig?.chart_type === "kpi" ||
          widgetGraphConfig?.chart_type === "heatmap" ||
          widgetGraphConfig?.chart_type === "map" ||
          widgetGraphConfig?.chart_type === "sunburst" ||
          widgetGraphConfig?.chart_type === "scatter" ||
          widgetGraphConfig?.chart_type === "multilayer-map" ||
          widgetGraphConfig?.chart_type === "quadrant" ||
          widgetGraphConfig?.chart_type === "bubble" ||
          widgetGraphConfig?.chart_type === "wordcloud" ||
          widgetGraphConfig?.chart_type === "grid" ||
          widgetGraphConfig?.chart_type === "post-card" ||
          widgetGraphConfig?.chart_type === "news-card" ||
          widgetGraphConfig?.chart_type === "sankey" ||
          widgetGraphConfig?.chart_type === "review-card" ||
          widgetGraphConfig?.chart_type === "author-card" ||
          widgetGraphConfig?.chart_type === "survey-card" ||
          widgetGraphConfig?.chart_type === "prolific-user" ||
          widgetGraphConfig?.chart_type === "treemap" ||
          widgetGraphConfig?.chart_type === "pivot-grid" ||
          widgetGraphConfig?.chart_type === "cluster-chart" ? (
            ""
          ) : (
            <>
              <Checkbox
                value="Show Data Labels"
                className="text_regular m-0 mb-2 d-flex "
                onChange={SelectCombinationSetting}
                checked={dataLabel}
              >
                Show Data Labels
              </Checkbox>
            </>
          )}
          {/* {widgetGraphConfig?.chart_type === "network-graph" ? (
            <>
              <Checkbox
                value="dynamic_radius"
                className="text_regular d-block m-0 mb-2 line-height-normal d-flex align-items-start "
                onChange={SelectCombinationSetting}
                checked={dynamicRadius}
              >
                Show Dynamic Radius
              </Checkbox>
              <Checkbox
                value="border_sentiment"
                className="text_regular d-block m-0 mb-2 line-height-normal d-flex align-items-start "
                onChange={SelectCombinationSetting}
                checked={borderSentiment}
              >
                Show Sentiment Border
              </Checkbox>
            </>
          ) : (
            ""
          )} */}
          {widgetGraphConfig?.chart_type === "treemap" ? (
            <>
              <Tooltip
                placement="top"
                title={
                  !widgetGraphConfig?.y_axis?.y_series_2?.attribute
                    ? "Feature available only for Treemap with more than one Y-series"
                    : ""
                }
              >
                <Checkbox
                  value="Show Details on Card"
                  className="text_regular m-0 mb-2 d-flex "
                  onChange={SelectCombinationSetting}
                  checked={showDetailsOnCard}
                  disabled={!widgetGraphConfig?.y_axis?.y_series_2?.attribute}
                >
                  Details on card
                  <Tooltip
                    placement="top"
                    title={
                      !widgetGraphConfig?.y_axis?.y_series_2?.attribute
                        ? ""
                        : "Details will be shown as data labels on the treemap chart"
                    }
                  >
                    <img
                      src={informationButton}
                      alt="Info"
                      className="cursor-pointer ml-2"
                      style={{ maxWidth: "1.6rem" }}
                    />
                  </Tooltip>
                </Checkbox>
              </Tooltip>

              <Checkbox
                value="Gradient Color"
                className="text_regular m-0 mb-2 d-flex align-items-start"
                onChange={SelectCombinationSetting}
                checked={gradientColor}
              >
                Gradient Color
                <Tooltip title="Treemap charts colors can be customized only when gradient color is enabled">
                  <i
                    className="fa fa-info-circle cursor-pointer ml-1"
                    style={{ color: "#A020F0" }}
                  />
                </Tooltip>
              </Checkbox>
            </>
          ) : (
            ""
          )}
          {widgetGraphConfig?.chart_type === "heatmap" ||
          widgetGraphConfig?.chart_type === "treemap" ? (
            <>
              <div
                className={`pl-1 ${
                  widgetGraphConfig?.chart_type === "treemap" && !gradientColor
                    ? "disable"
                    : ""
                }`}
              >
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <div className="line-height-normal text_heading text-transform__capitalize">
                    Start Color:
                  </div>
                  <Input
                    type="color"
                    value={
                      chartStyles?.startColor
                        ? chartStyles?.startColor
                        : "#fa1919"
                    }
                    onChange={(e) =>
                      handleChartStyles(e.target.value, "startColor")
                    }
                    className="ChartStyles--colorInput"
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <div className="line-height-normal text_heading text-transform__capitalize">
                    End Color:
                  </div>
                  <Input
                    type="color"
                    value={
                      chartStyles?.endColor ? chartStyles?.endColor : "#185edf"
                    }
                    onChange={(e) =>
                      handleChartStyles(e.target.value, "endColor")
                    }
                    className="ChartStyles--colorInput"
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <div className="line-height-normal text_heading text-transform__capitalize">
                    Data Label Color:
                  </div>
                  <Input
                    type="color"
                    value={
                      chartStyles?.dataLabelColor
                        ? chartStyles?.dataLabelColor
                        : "#000000"
                    }
                    onChange={(e) =>
                      handleChartStyles(e.target.value, "dataLabelColor")
                    }
                    className="ChartStyles--colorInput"
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {["scatter", "quadrant"]?.includes(widgetGraphConfig?.chart_type) ? (
            <Checkbox
              value="SwitchToMedian"
              className="text_regular m-0 mb-2  d-flex "
              onChange={SelectCombinationSetting}
              checked={switchToMedian}
            >
              Switch to quadrant
              <Tooltip
                placement="top"
                title="Customize Median value in Series settings"
              >
                <img
                  src={informationButton}
                  alt="Info"
                  className="cursor-pointer ml-2"
                  style={{ maxWidth: "1.6rem" }}
                />
              </Tooltip>
            </Checkbox>
          ) : (
            " "
          )}
          {widgetGraphConfig?.chart_type === "bar" ||
          widgetGraphConfig?.chart_type === "horizontal-bar" ||
          // widgetGraphConfig?.chart_type === "area" ||
          widgetGraphConfig?.chart_type === "pie" ||
          widgetGraphConfig?.chart_type === "donut" ? (
            <>
              <Checkbox
                value="Enable 3D"
                className="text_regular m-0 mb-2 d-flex"
                onChange={SelectCombinationSetting}
                checked={enable3D}
              >
                Show in 3D
                <Tooltip
                  placement="top"
                  title="Benchmarking chart is not supported for 3D chart"
                >
                  <img
                    src={informationButton}
                    alt="Info"
                    className="cursor-pointer ml-2"
                    style={{ maxWidth: "1.6rem" }}
                  />
                </Tooltip>
              </Checkbox>
              {showSliders && (
                <Row gutter={16}>
                  <Col span={20}>
                    <label>Alpha</label>
                    <Slider
                      defaultValue={
                        widgetGraphConfig?.chart_settings?.settings_3d
                          ? widgetGraphConfig?.chart_settings?.settings_3d
                              ?.alpha
                          : DEFAULT_CHART_SETTINGS[
                              widgetGraphConfig?.chart_type
                            ]?.alpha ?? 0
                      }
                      onChange={(value) => handleSliderChange(value, "alpha")}
                    />
                  </Col>
                  <Col span={20}>
                    <label>Beta</label>
                    <Slider
                      defaultValue={
                        widgetGraphConfig?.chart_settings?.settings_3d
                          ? 19
                          : DEFAULT_CHART_SETTINGS[
                              widgetGraphConfig?.chart_type
                            ]?.beta ?? 0
                      }
                      onChange={(value) => handleSliderChange(value, "beta")}
                    />
                  </Col>
                  <Col span={20}>
                    <label>Depth</label>
                    <Slider
                      defaultValue={
                        widgetGraphConfig?.chart_settings?.settings_3d
                          ? widgetGraphConfig?.chart_settings?.settings_3d
                              ?.depth
                          : DEFAULT_CHART_SETTINGS[
                              widgetGraphConfig?.chart_type
                            ]?.beta ?? 0
                      }
                      onChange={(value) => handleSliderChange(value, "depth")}
                    />
                  </Col>
                </Row>
              )}
            </>
          ) : (
            ""
          )}

          {(pathName === "widgetmaker" || pathName === "edit-widget") &&
          !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
          (widgetGraphConfig?.chart_type === "wordcloud" ||
            widgetGraphConfig?.chart_type === "grid" ||
            widgetGraphConfig?.chart_type === "post-card" ||
            widgetGraphConfig?.chart_type === "author-card") ? (
            <Checkbox
              value="Duplicate for selected brands"
              className="text_regular m-0 mb-2 line-height-normal d-flex"
              onChange={SelectCombinationSetting}
              checked={duplicateForBrands}
            >
              Duplicate for Competition Brands
            </Checkbox>
          ) : (
            " "
          )}
          {widgetGraphConfig?.chart_type !== "kpi" &&
            (widgetGraphConfig?.chart_type === "bar" ||
              widgetGraphConfig?.chart_type === "horizontal-bar" ||
              widgetGraphConfig?.chart_type === "area") &&
            widgetMakerGraphData &&
            widgetMakerGraphData[0]?.stacked && (
              <>
                {(widgetGraphConfig?.chart_type === "bar" ||
                  widgetGraphConfig?.chart_type === "horizontal-bar") &&
                  stacked && (
                    <>
                      <Checkbox
                        value="Percent Chart"
                        className="text_regular  m-0 mb-2 d-flex"
                        onChange={SelectCombinationSetting}
                        checked={dataLabelInPercent}
                      >
                        Percent Chart
                      </Checkbox>
                      <Checkbox
                        value="Gradient Color"
                        className="text_regular m-0 mb-2 d-flex"
                        onChange={SelectCombinationSetting}
                        checked={gradientColor}
                      >
                        Gradient Color
                      </Checkbox>
                    </>
                  )}
                <Checkbox
                  value="Stacked"
                  className="text_regular m-0 mb-2 d-flex"
                  onChange={SelectCombinationSetting}
                  checked={stacked}
                >
                  Stacked
                </Checkbox>
              </>
            )}

          {widgetGraphConfig?.chart_type === "combination" &&
          widgetGraphConfig?.breakdown_by?.length ? (
            <>
              {stacked && (
                <>
                  <Checkbox
                    value="Gradient Color"
                    className="text_regular d-flex  m-0 mb-2"
                    onChange={SelectCombinationSetting}
                    checked={gradientColor}
                  >
                    Gradient Color
                    <Tooltip title="Applicable only on bar charts">
                      <i
                        className="fa fa-info-circle cursor-pointer ml-1"
                        style={{ color: "#A020F0" }}
                      />
                    </Tooltip>
                  </Checkbox>
                </>
              )}
              <Checkbox
                value="Stacked"
                className="text_regular d-flex  m-0 mb-2"
                onChange={SelectCombinationSetting}
                checked={stacked}
                disabled={stackedDisabled}
              >
                Stacked
              </Checkbox>
            </>
          ) : (
            ""
          )}

          {(widgetGraphConfig?.card_settings[
            widgetGraphConfig?.card_settings?.length - 1
          ]?.response?.length > 0 ||
            widgetGraphConfig?.chart_type === "kpi") && (
            <>
              <Checkbox
                value="Previous Duration Comparison"
                className="text_regular d-flex  m-0 mb-2"
                onChange={SelectCombinationSetting}
                checked={durationComparision}
              >
                Previous Duration Comparison
              </Checkbox>
              <Checkbox
                value="Share of Data"
                className="text_regular d-flex  m-0 mb-2"
                onChange={SelectCombinationSetting}
                checked={shareOfData}
              >
                Share of Data
              </Checkbox>
            </>
          )}

          {showMarkers && (
            <>
              {widgetGraphConfig?.chart_type === "combination" ||
              widgetGraphConfig?.chart_type === "line" ||
              widgetGraphConfig?.chart_type === "area" ? (
                <>
                  <Checkbox
                    className="text_regular d-flex  m-0 mb-15"
                    onChange={(e) => handleChartMarkers(e)}
                    checked={markers}
                  >
                    Show Markers
                  </Checkbox>
                </>
              ) : (
                ""
              )}
            </>
          )}

          {widgetGraphConfig?.card_settings?.[
            widgetGraphConfig?.card_settings?.length - 1
          ]?.response?.length > 0 &&
            widgetGraphConfig?.chart_type !== "post-card" &&
            widgetGraphConfig?.chart_type !== "survey-card" &&
            widgetGraphConfig?.chart_type !== "prolific-user" &&
            widgetGraphConfig?.chart_type !== "review-card" &&
            widgetGraphConfig?.chart_type !== "author-card" &&
            widgetGraphConfig?.chart_type !== "kpi" && (
              <Checkbox
                value="split_cards"
                className="text_regular m-0 mb-2 line-height-normal d-flex "
                onChange={SelectCombinationSetting}
                checked={splitCards}
              >
                Show Split Cards
              </Checkbox>
            )}
          {["post-card", "wordcloud", "review-card"]?.includes(
            widgetGraphConfig?.chart_type
          ) &&
          ((Array.isArray(widgetGraphConfig?.filter_by) &&
            widgetGraphConfig?.filter_by?.length) ||
            widgetGraphConfig?.breakdown_by?.length) ? (
            <Checkbox
              value="show_header"
              className="text_regular font-weight400 m-0 mb-2"
              onChange={SelectCombinationSetting}
              checked={showFilterByHeader}
            >
              Show Filter By Header
            </Checkbox>
          ) : (
            ""
          )}
          {widgetGraphConfig?.chart_type === "post-card" && (
            <Checkbox
              value="top_posts_in_cards"
              className="text_regular m-0 mb-2 line-height-normal d-flex "
              onChange={SelectCombinationSetting}
              checked={topPosts}
            >
              Show Top Brand Posts only
            </Checkbox>
          )}
        </div>
        {["grid", "multilayer-map", "treemap"]?.includes(
          widgetGraphConfig?.chart_type
        ) ? (
          <div className="pl-15">
            <div className="font-weight600 mb-15 line-height-normal text_heading text-transform__capitalize">
              Duration Comparison
            </div>
            {["grid", "multilayer-map", "treemap"]?.includes(
              widgetGraphConfig?.chart_type
            ) ? (
              <>
                <Checkbox
                  value="PreviousDurationComparisonForChart"
                  className="text_regular m-0 mb-2 line-height-normal d-flex "
                  onChange={SelectCombinationSetting}
                  checked={durationComparisionForChart}
                >
                  Percent Change
                </Checkbox>
                {["grid", "multilayer-map"]?.includes(
                  widgetGraphConfig?.chart_type
                ) ? (
                  <Checkbox
                    value="PreviousDurationDataForChart"
                    className="text_regular m-0 mb-2 line-height-normal d-flex "
                    onChange={SelectCombinationSetting}
                    checked={durationDataForChart}
                  >
                    Show Data
                  </Checkbox>
                ) : (
                  ""
                )}
                {/* <Checkbox
                  value="ShowMinMaxData"
                  className="text_regular m-0 mb-2 line-height-normal d-flex "
                  onChange={SelectCombinationSetting}
                  checked={showMinMaxData}
                >
                  Show Peak Value
                </Checkbox> */}
              </>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}

        {/* Show Peak And Valley options for grid and pivot-grid */}
        {supportedChartTypesForPeakAndValley?.includes(
          widgetGraphConfig?.chart_type
        ) ? (
          <>
            <div className="pl-15">
              <Tooltip
                title={
                  (widgetGraphConfig?.chart_type === "bar" ||
                    widgetGraphConfig?.chart_type === "horizontal-bar") &&
                  widgetGraphConfig?.breakdown_by?.length
                    ? "This feature works without breakdown by attribute only."
                    : showBenchmarkTraceOptions &&
                      supportedBenchmarkTraceChartTypes?.includes(
                        widgetGraphConfig?.chart_type
                      ) &&
                      benchmark_line
                    ? "Selection not allowed with Benchmarking."
                    : ""
                }
              >
                <Checkbox
                  disabled={
                    (widgetGraphConfig?.chart_type === "bar" ||
                      widgetGraphConfig?.chart_type === "horizontal-bar") &&
                    widgetGraphConfig?.breakdown_by?.length
                      ? true
                      : showBenchmarkTraceOptions &&
                        supportedBenchmarkTraceChartTypes?.includes(
                          widgetGraphConfig?.chart_type
                        ) &&
                        benchmark_line
                      ? true
                      : false
                  }
                  value="ShowMaxData"
                  className="text_regular m-0 mb-2 line-height-normal d-flex "
                  onChange={SelectCombinationSetting}
                  checked={showPeak}
                >
                  <div className="d-flex align-items-center">
                    Show Peak{" "}
                    {widgetGraphConfig?.chart_type === "grid" ||
                    widgetGraphConfig?.chart_type === "pivot-grid" ? (
                      <div className="peak-value-circle"></div>
                    ) : (
                      ""
                    )}
                  </div>
                </Checkbox>
              </Tooltip>
              <Tooltip
                title={
                  (widgetGraphConfig?.chart_type === "bar" ||
                    widgetGraphConfig?.chart_type === "horizontal-bar") &&
                  widgetGraphConfig?.breakdown_by?.length
                    ? "This feature works without breakdown by attribute only."
                    : showBenchmarkTraceOptions &&
                      supportedBenchmarkTraceChartTypes?.includes(
                        widgetGraphConfig?.chart_type
                      ) &&
                      benchmark_line
                    ? "Selection not allowed with Benchmarking."
                    : ""
                }
              >
                <Checkbox
                  disabled={
                    (widgetGraphConfig?.chart_type === "bar" ||
                      widgetGraphConfig?.chart_type === "horizontal-bar") &&
                    widgetGraphConfig?.breakdown_by?.length
                      ? true
                      : showBenchmarkTraceOptions &&
                        supportedBenchmarkTraceChartTypes?.includes(
                          widgetGraphConfig?.chart_type
                        ) &&
                        benchmark_line
                      ? true
                      : false
                  }
                  value="ShowMinData"
                  className="text_regular m-0 mb-2 line-height-normal d-flex "
                  onChange={SelectCombinationSetting}
                  checked={showValley}
                >
                  <div className="d-flex align-items-center">
                    Show Valley
                    {widgetGraphConfig?.chart_type === "grid" ||
                    widgetGraphConfig?.chart_type === "pivot-grid" ? (
                      <div className="valley-value-circle"></div>
                    ) : (
                      ""
                    )}
                  </div>
                </Checkbox>
              </Tooltip>
            </div>
          </>
        ) : (
          ""
        )}
        {showBenchmarkTraceOptions &&
        supportedBenchmarkTraceChartTypes?.includes(
          widgetGraphConfig?.chart_type
        ) ? (
          <div className="pl-15 pr-15">
            {/* <div className="text_regular font-weight600">
          Benchmark Aggregation
          </div> */}
            <Tooltip
              title={
                ["bar", "horizontal-bar", "grid", "pivot-grid"]?.includes(
                  widgetGraphConfig?.chart_type
                ) &&
                (showPeak || showValley)
                  ? "Disable Peak & Valley options to enable Benchmarking."
                  : ""
              }
            >
              <Checkbox
                value="Benchmark Line"
                className="text_regular font-weight400"
                onChange={handleBenchmarkLine}
                checked={benchmark_line}
                disabled={
                  ["bar", "horizontal-bar", "grid", "pivot-grid"]?.includes(
                    widgetGraphConfig?.chart_type
                  )
                    ? showPeak || showValley
                    : false
                }
              >
                Show Benchmark Trace
                <Tooltip
                  placement="top"
                  title="Benchmarking always work on first y-series attribute if multiple y-series are present."
                >
                  <img
                    src={informationButton}
                    alt="Info"
                    className="cursor-pointer ml-2"
                    style={{ maxWidth: "1.6rem" }}
                  />
                </Tooltip>
              </Checkbox>
            </Tooltip>
            {benchmark_line ? (
              <div className="floating-label-group header-brands mt-15">
                <Select
                  //defaultValue="None"
                  value={groupLineAgg ? groupLineAgg : null}
                  onChange={(e) => changeSeriesAggregation(e)}
                  className="w-100"
                >
                  {benchmarkAggregation &&
                  Array.isArray(benchmarkAggregation) ? (
                    <>
                      {benchmarkAggregation?.map((aggrigation, i) => {
                        return (
                          <Option
                            key={`banchmark_aggregation_${i}`}
                            value={aggrigation?.value}
                          >
                            {aggrigation?.label}
                          </Option>
                        );
                      })}
                    </>
                  ) : (
                    ""
                  )}
                </Select>
                <label
                  className="portlet-label floating-label bg__white font-size12"
                  style={{ top: "-8px" }}
                >
                  Benchmark Aggregation
                </label>
              </div>
            ) : (
              ""
            )}
            {benchmark_line && groupLineAgg === "custom" ? (
              <>
                <div className="w-100 mt-15 mb-3">
                  <div className="position-relative chartName floating-label-group mt-3">
                    <InputNumber
                      required
                      id={`benchmark_static_value`}
                      //label="Limit"
                      //placeholder="Enter limit"
                      type="number"
                      min={1}
                      // max={100} // not using this because it is stoping onchange when reach max limit
                      value={benchmarkValueConfig?.value}
                      onChange={(num) => {
                        handleChangeBrandBenchmarkStaticValue(num);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // stringMode={true}
                      className="border-radius-4 border-color w-100"
                      autocompleteDisabled={true}
                      disabled={false}
                    />
                    <label
                      className="portlet-label floating-label bg__white font-size12"
                      htmlFor={`benchmark_static_value`}
                    >
                      Benchmark Value
                      {/* <span className="error">*</span> */}
                    </label>
                  </div>
                  {showErrorMessageForBenchmarkValue ? (
                    <>
                      {benchmarkValueConfig?.max !== null ? (
                        <div className="error position-absolute font-size12 error">
                          {`Enter a limit between ${benchmarkValueConfig?.min} and ${benchmarkValueConfig?.max}.`}
                        </div>
                      ) : (
                        <div className="error position-absolute font-size12 error">
                          {`Enter a valid number.`}
                        </div>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}

        <ChartSettingCard
          yAxis={
            widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
            widgetGraphConfig?.y_axis
          }
        />
      </div>
    </>
  );
};

export default ChartSetting;
